import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    // 首页
    path: '/',
    name: 'home',
    component: () => import('@/components/HomePage.vue')
  },
  {
    // 产品介绍
    path: '/product',
    name: 'product',
    component: () => import('@/components/ProductPage.vue')
  },
  {
    // 核心技术
    path: '/technology',
    name: 'technology',
    component: () => import('@/components/TechnologyPage.vue')
  },
  {
    // 招商与合作
    path: '/cooperation',
    name: 'cooperation',
    component: () => import('@/components/CooperationPage.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 使用路由跳转页面时回到页面最顶端，使用路由的全局前置守卫
router.beforeEach((to, from, next) => {
  // 在每次导航之前滚动到页面顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 可选的，使滚动平滑进行
  })
  next()
})

export default router
